import React from "react";
import { Form, Table, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

const CatalogRegions = ({ regions, onChange, onAdd, onRemove, viewOnly, loading }) => (
  <div className="mb-3">
    <div className="d-flex justify-content-between align-items-center mb-1">
      <h6 className="mb-0">Regions</h6>
      {!viewOnly && (
        <Button variant="outline-primary" size="sm" onClick={onAdd} disabled={loading}>
          <FontAwesomeIcon icon={faPlus} className="me-1" />
          Add
        </Button>
      )}
    </div>

    {!loading && regions.length === 0 && <p className="text-muted mb-0">No regions.</p>}

    {regions.length > 0 && (
      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
        <Table striped bordered hover size="sm" className="mb-0">
          <thead style={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Description</th>
              <th scope="col" style={{ width: "60px" }}></th>
            </tr>
          </thead>
          <tbody>
            {regions.map((region) => (
              <tr key={region.clientKey}>
                <td>
                  <Form.Control
                    type="text"
                    size="sm"
                    placeholder="Enter region name"
                    value={region.name}
                    onChange={(e) => onChange(region.clientKey, "name", e.target.value)}
                    disabled={viewOnly}
                  />
                </td>
                <td>
                  <Form.Control
                    type="text"
                    size="sm"
                    placeholder="Enter region description"
                    value={region.description || ""}
                    onChange={(e) => onChange(region.clientKey, "description", e.target.value)}
                    disabled={viewOnly}
                  />
                </td>
                <td className="text-center">
                  {!viewOnly && (
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => onRemove(region.clientKey)}
                      aria-label={`Remove region ${region.name}`}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    )}
  </div>
);

export default CatalogRegions;
